module.exports = __webpack_public_path__ + "img/sign2.1630993415105.png";